import 'react-datepicker/dist/react-datepicker.css'
import moment from 'moment'
import styled from 'styled-components'

import { ItemHeader } from '@/components/Style/Common'
import type { Address } from '@/types/Activity'

const EmploymentDetails = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  grid-gap: 10px;
`

const SmallIcon = styled.img`
  width: 12px;
  height: 12px;
  margin-right: 5px;
`

interface Props {
  company: string
  position: string
  contractType: string
  address: Address
  contractSchedule: string
  startDate: string
  endDate: string
}

const EmploymentIncomeDetails: React.FC<Props> = ({
  company,
  position,
  contractType,
  address,
  contractSchedule,
  startDate,
  endDate,
}) => (
  <div>
    <EmploymentDetails>
      <div>
        {company && (
          <>
            <ItemHeader>Employer Name</ItemHeader>
            <p>{company}</p>
          </>
        )}
        {position && (
          <>
            <ItemHeader>Position held</ItemHeader>
            <p>{position}</p>
          </>
        )}
        {contractType && (
          <>
            <ItemHeader>Contract Type</ItemHeader>
            <p>{contractType}</p>
          </>
        )}
      </div>
      {address && (
        <div>
          <ItemHeader>Employer Address</ItemHeader>
          <p>{address.line1}</p>
          <p>{address.city}</p>
          <p>{address.postcode}</p>
          <p>{address.country}</p>
        </div>
      )}
    </EmploymentDetails>
    <EmploymentDetails>
      {contractSchedule && (
        <div>
          <ItemHeader>Employment Basis</ItemHeader>
          <p>{contractSchedule}</p>
        </div>
      )}
      <div>
        <ItemHeader>Employment Started</ItemHeader>
        <div className="side-by-side-flex-start">
          {' '}
          <SmallIcon src="/assets/svg/calendar.svg" alt="" />{' '}
          <p> {moment.utc(startDate).format('LL')}</p>
        </div>
      </div>

      {endDate && (
        <div>
          <ItemHeader>Employment is due to end</ItemHeader>
          <div className="side-by-side-flex-start">
            {' '}
            <SmallIcon src="/assets/svg/calendar.svg" alt="" />{' '}
            <p> {moment.utc(endDate).format('LL')}</p>
          </div>
        </div>
      )}
    </EmploymentDetails>
  </div>
)

export default EmploymentIncomeDetails
